import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Utils }  from '../../providers/utils/utils';
import { Clipboard } from '@ionic-native/clipboard';

/*
*
*  Logs Page
*
*/
@Component({
  selector: 'logs',
  templateUrl: 'logs.html'
})
export class Logs {
    constructor(
        private utils: Utils,
        private navCtrl: NavController,
        private clipboard: Clipboard
    ) {
    }

    copy() {

        let logs = '';

        for(let log of this.utils.logs) {
             logs+=log.time+ ' '+ log.message +"\n";
        }

        this.clipboard.copy(logs);
        this.utils.success('Logs added to clipboard');
    }

    pop() {
    	this.navCtrl.pop()
    }

}



// WEBPACK FOOTER //
// ./src/pages/logs/logs.ts